// webPushKeys — the VAPID PUBLIC keys, one per Supabase project, in code.
//
// Mirror of netlify/functions/_web-push-keys.js (a test asserts the two tables
// are identical). A VAPID public key is not a secret — every subscribed
// browser holds a copy — so it ships in the bundle; only the PRIVATE key is a
// Netlify env var (Umer, 2026-09-16). The page picks the key for the project
// it talks to by the Supabase URL it already has, so a staging build can never
// subscribe browsers to production's identity or the other way round.
export const WEB_PUSH_PUBLIC_KEYS: Record<string, string> = {
  // stagingwolfdriver.netlify.app → Supabase project hozsxkigvarwlqmsbomv
  hozsxkigvarwlqmsbomv: 'BMqKHpeelysugzEeggZ21Qlc00tQWp4K5NI0OxxNCyDB90QJXpf8LgNcHx6S50yZb2Gantb0iQKSA91HHU-dpWU',
  // wolfdrivers.com → Supabase project xyrnbzthnvanwusddatk (generated 2026-09-17; private key lives on the wolfdrivers.com site)
  xyrnbzthnvanwusddatk: 'BEgvKfLFrOUjr5m7H4x3b3wNEcCCkUyHnExSvrK8wpmp60Cq2hyfMQ2TgRg4oMV7oHpzcim5lKrKO8S_STmjG-k',
};

export const WEB_PUSH_SUBJECT = 'mailto:info@uperweedca.com';

/** Project ref (`<ref>.supabase.co`) out of a Supabase URL, or ''. */
export function projectRefFromUrl(url: string | undefined | null): string {
  const m = /^https?:\/\/([a-z0-9]+)\.supabase\.co/i.exec(String(url || ''));
  return m ? m[1].toLowerCase() : '';
}

/** The public key for a Supabase URL ('' when unknown / not generated). */
export function publicKeyForUrl(url: string | undefined | null): string {
  return WEB_PUSH_PUBLIC_KEYS[projectRefFromUrl(url)] || '';
}
